/*
  File: src/components/home/CategoryChips.jsx
  Purpose: Futuristic selectable chips used as filters.
  Props:
    - categories: string[]
    - selected?: string | string[]
    - onChange?: (nextSelected: string | string[]) => void
    - multiSelect?: boolean (default false)
*/
import React from 'react';

/**
 * CategoryChips
 * Selectable pill buttons to filter or highlight categories.
 */
function CategoryChips({ categories, selected, onChange, multiSelect = false }) {
  const isSelected = (c) => {
    if (Array.isArray(selected)) return selected.includes(c);
    return selected === c;
  };

  const handleClick = (c) => {
    if (!onChange) return; // Non-controlled usage
    if (multiSelect) {
      const current = Array.isArray(selected) ? selected : [];
      const next = current.includes(c) ? current.filter((x) => x !== c) : [...current, c];
      onChange(next);
    } else {
      onChange(selected === c ? '' : c);
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {categories.map((c) => {
        const active = isSelected(c);
        return (
          <button
            key={c}
            onClick={() => handleClick(c)}
            className={`text-xs rounded-full px-3 py-1.5 transition-all duration-200 border backdrop-blur-sm ${
              active
                ? 'border-cyan-400/50 text-cyan-200 bg-cyan-500/15 shadow-[0_0_18px_rgba(34,211,238,0.25)]'
                : 'border-white/10 text-white/80 bg-white/5 hover:border-fuchsia-400/40 hover:bg-fuchsia-500/10 hover:text-white'
            }`}
          >
            {c}
          </button>
        );
      })}
    </div>
  );
}

export default CategoryChips;


